import { PrivateDocResponseDto } from '@docbay/schemas';
import { PrivateDoctorUpdateParams } from 'common/types/privateDoctor';
import axiosInstance from 'integration/api/axiosInstance';

/**
 * API module for private doctors.
 */
export const PrivateDoctorAPI = {
  /**
   * Retrieves the details of a private doctor by their ID.
   *
   * @param id - The ID of the private doctor to retrieve.
   * @returns An Axios response containing the retrieved private doctor's details in the form of a `PrivateDocResponseDto`.
   */
  getPrivateDoctor: (id: string) =>
    axiosInstance.get<PrivateDocResponseDto>(`/private-doctor/${id}`),

  /**
   * Updates the details of a private doctor by their ID.
   *
   * @param params - An object containing the ID of the private doctor to update and the new data to apply.
   * @returns An Axios response containing the updated private doctor's details in the form of a `PrivateDocResponseDto`.
   */
  updatePrivateDoctor: ({ id, data }: PrivateDoctorUpdateParams) => {
    return axiosInstance.patch<PrivateDocResponseDto>(
      `/private-doctor/${id}`,
      data,
    );
  },
};
